import PropTypes from "prop-types";
import { useNavigate } from "react-router";
import CloseButton from "../CloseButton";

import sitePaths from "../../../constants/sitePaths";
import { text } from "../../../constants/text";
import { useQuery } from "../../../utils/useQuery";

export const useTilbakeknapp = (computedMatch) => {
  const query = useQuery();
  const navigate = useNavigate();

  const handleClick = () => {
    // pathnameArray[0] is empty string
    const pathnameArray = window.location.pathname.split("/");
    if (
      pathnameArray.length > 3 &&
      pathnameArray[1] === "ileggelser" &&
      pathnameArray[2] === "oversikt"
    ) {
      navigate(sitePaths.ileggelser.oversikt.shortUrl);
    } else if (
      pathnameArray.length > 3 &&
      pathnameArray[1] === "ileggelser" &&
      pathnameArray[2] === "ettersendelser"
    ) {
      navigate(sitePaths.ileggelser.ettersendelser.shortUrl);
    } else if (
      pathnameArray.length > 3 &&
      pathnameArray[1] === "ileggelser" &&
      pathnameArray[2] === "ettersendelser-til-godkjenning"
    ) {
      navigate(sitePaths.ileggelser.ettersendelserTilGodkjenning.shortUrl);
    } else if (
      pathnameArray.length > 3 &&
      pathnameArray[1] === "ileggelser" &&
      pathnameArray[2] === "elsparksykkel-gebyr"
    ) {
      navigate(sitePaths.ileggelser.elsparksykkelGebyr.shortUrl);
    } else if (
      window.location.pathname.search(
        sitePaths.rapporter.ubetalteIleggelser.detalj.ileggelser.matcher,
      ) === 0
    ) {
      navigate({
        pathname: sitePaths.rapporter.ubetalteIleggelser.detalj.getUrl(
          computedMatch?.params?.kjoretoyId,
        ),
        search: `?ileggelseType=${query.get("ileggelseType")}`,
      });
    } else if (
      pathnameArray.length > 5 &&
      pathnameArray[1] === "miljogebyrer" &&
      pathnameArray[2] === "oversikt" &&
      pathnameArray[4] === "tidskontroller"
    ) {
      navigate(sitePaths.miljogebyrer.oversikt.detalj.getUrl(pathnameArray[3]));
    } else if (
      pathnameArray.length > 3 &&
      pathnameArray[1] === "miljogebyrer" &&
      pathnameArray[2] === "oversikt"
    ) {
      navigate(sitePaths.miljogebyrer.oversikt.shortUrl);
    } else if (
      pathnameArray.length > 5 &&
      pathnameArray[1] === "miljogebyrer" &&
      pathnameArray[2] === "til-behandling" &&
      pathnameArray[4] === "tidskontroller"
    ) {
      navigate(
        sitePaths.miljogebyrer.tilBehandling.detalj.getUrl(pathnameArray[3]),
      );
    } else if (
      pathnameArray.length > 3 &&
      pathnameArray[1] === "miljogebyrer" &&
      pathnameArray[2] === "til-behandling"
    ) {
      navigate(sitePaths.miljogebyrer.tilBehandling.shortUrl);
    } else if (
      pathnameArray.length > 6 &&
      pathnameArray[1] === "miljogebyrer" &&
      pathnameArray[2] === "tidskontrolloversikt" &&
      pathnameArray[3] === "miljogebyrer" &&
      pathnameArray[5] === "tidskontroller"
    ) {
      navigate(
        sitePaths.miljogebyrer.miljokontrolloversikt.miljogebyrer.detalj.getUrl(
          pathnameArray[4],
        ),
      );
    } else if (
      pathnameArray.length > 5 &&
      pathnameArray[1] === "miljogebyrer" &&
      pathnameArray[2] === "tidskontrolloversikt" &&
      pathnameArray[4] === "miljogebyrer"
    ) {
      navigate(
        sitePaths.miljogebyrer.miljokontrolloversikt.detalj.getUrl(
          pathnameArray[3],
        ),
      );
    } else if (
      pathnameArray.length > 3 &&
      pathnameArray[1] === "miljogebyrer" &&
      pathnameArray[2] === "tidskontrolloversikt"
    ) {
      navigate(sitePaths.miljogebyrer.miljokontrolloversikt.shortUrl);
    } else if (
      pathnameArray.length > 3 &&
      pathnameArray[1] === "innsyn" &&
      pathnameArray[2] === "ileggelser"
    ) {
      navigate(sitePaths.innsyn.ileggelser.oversikt);
    } else if (
      pathnameArray.length > 3 &&
      pathnameArray[1] === "innsyn" &&
      pathnameArray[2] === "miljogebyrer"
    ) {
      navigate(sitePaths.innsyn.miljogebyrer.oversikt);
    } else if (
      pathnameArray.length > 5 &&
      pathnameArray[1] === "klage" &&
      pathnameArray[2] === "miljogebyrer" &&
      pathnameArray[4] === "tidskontroller"
    ) {
      navigate(sitePaths.klage.miljogebyrer.detalj.getUrl(pathnameArray[3]));
    } else if (pathnameArray.length > 2 && pathnameArray[1] === "klage") {
      navigate(sitePaths.klage.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "ileggelser" &&
      pathnameArray[3] === "venter"
    ) {
      navigate(sitePaths.innkreving.ileggelser.venter.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "ileggelser" &&
      pathnameArray[3] === "stoppet"
    ) {
      navigate(sitePaths.innkreving.ileggelser.stoppet.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "ileggelser" &&
      pathnameArray[3] === "klar"
    ) {
      navigate(sitePaths.innkreving.ileggelser.klar.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "ileggelser" &&
      pathnameArray[3] === "behandles-innkreving"
    ) {
      navigate(sitePaths.innkreving.ileggelser.behandlesInnkreving.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "ileggelser" &&
      pathnameArray[3] === "klar"
    ) {
      navigate(sitePaths.innkreving.ileggelser.feilet.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "ileggelser" &&
      pathnameArray[3] === "feilet"
    ) {
      navigate(sitePaths.innkreving.ileggelser.feilet.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "ileggelser" &&
      pathnameArray[3] === "vellykket"
    ) {
      navigate(sitePaths.innkreving.ileggelser.vellykket.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "miljogebyr" &&
      pathnameArray[3] === "venter"
    ) {
      navigate(sitePaths.innkreving.miljogebyr.venter.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "miljogebyr" &&
      pathnameArray[3] === "stoppet"
    ) {
      navigate(sitePaths.innkreving.miljogebyr.stoppet.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "miljogebyr" &&
      pathnameArray[3] === "klar"
    ) {
      navigate(sitePaths.innkreving.miljogebyr.klar.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "miljogebyr" &&
      pathnameArray[3] === "behandles-innkreving"
    ) {
      navigate(sitePaths.innkreving.miljogebyr.behandlesInnkreving.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "miljogebyr" &&
      pathnameArray[3] === "feilet"
    ) {
      navigate(sitePaths.innkreving.miljogebyr.feilet.shortUrl);
    } else if (
      pathnameArray.length > 4 &&
      pathnameArray[1] === "innkreving" &&
      pathnameArray[2] === "miljogebyr" &&
      pathnameArray[3] === "vellykket"
    ) {
      navigate(sitePaths.innkreving.miljogebyr.vellykket.shortUrl);
    } else if (
      isIleggelseUnderVentilstillingDetailPage() &&
      pathnameArray[-1] === "rediger"
    ) {
      navigate(
        sitePaths.rapporter.ventilstillinger.detalj.getUrl(pathnameArray[3]),
      );
    } else if (
      isIleggelseUnderVentilstillingDetailPage() &&
      pathnameArray[-1] === "historikk"
    ) {
      navigate(
        sitePaths.rapporter.ventilstillinger.detalj.getUrl(pathnameArray[3]),
      );
    } else if (
      isIleggelseUnderVentilstillingDetailPage() &&
      pathnameArray[-3] === "bilder"
    ) {
      navigate(
        sitePaths.rapporter.ventilstillinger.detalj.getUrl(pathnameArray[3]),
      );
    } else if (isIleggelseUnderVentilstillingDetailPage()) {
      navigate(
        sitePaths.rapporter.ventilstillinger.detalj.getUrl(pathnameArray[3]),
      );
    } else if (
      isIleggelseUnderVentilstillingOverviewPage() &&
      pathnameArray[-1] === "rediger"
    ) {
      navigate(sitePaths.rapporter.ventilstillinger.shortUrl);
    } else if (
      isIleggelseUnderVentilstillingOverviewPage() &&
      pathnameArray[-1] === "historikk"
    ) {
      navigate(sitePaths.rapporter.ventilstillinger.shortUrl);
    } else if (
      isIleggelseUnderVentilstillingOverviewPage() &&
      pathnameArray[-3] === "bilder"
    ) {
      navigate(sitePaths.rapporter.ventilstillinger.shortUrl);
    } else if (isIleggelseUnderVentilstillingOverviewPage()) {
      navigate(sitePaths.rapporter.ventilstillinger.shortUrl);
    } else if (isVentilstillingDetailPage()) {
      navigate(sitePaths.rapporter.ventilstillinger.oversikt);
    } else {
      console.error("Ingen definert tilbakeknapp for denne siden");
    }
  };

  return handleClick;
};

const styles = {
  topHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: 50,
    paddingRight: 50,
    marginBottom: 41,
  },
  badgeMakulert: { fontSize: 28 },
};

const DetaljPageHeader = ({
  pageName,
  pageId,
  isMakulert,
  makulertTekst,
  computedMatch,
  customCloseButtonText,
  customHeader,
}) => {
  const handleClickTilbakeknapp = useTilbakeknapp(computedMatch);

  const badgeText = makulertTekst ? makulertTekst : "Makulert";

  return (
    <div style={styles.topHeader}>
      {customHeader ? (
        customHeader
      ) : (
        <h1>
          {pageName} <strong>{pageId}</strong>
          {isMakulert && (
            <span style={styles.badgeMakulert}>
              &nbsp;
              <span className="badge-bym-red">{badgeText}</span>
            </span>
          )}
        </h1>
      )}
      <span className="no-print">
        <CloseButton
          customHandleClick={handleClickTilbakeknapp}
          text={
            customCloseButtonText ?? text.detailPage.closeButtonText(pageName)
          }
        />
      </span>
    </div>
  );
};

DetaljPageHeader.propTypes = {
  pageName: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
};

export default DetaljPageHeader;

const REGEX_GUID =
  "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

const isIleggelseUnderVentilstillingOverviewPage = () => {
  return (
    window.location.pathname.search(
      new RegExp(`^/rapporter/ventilstillinger/ileggelse/${REGEX_GUID}$`),
    ) !== -1
  );
};

const isIleggelseUnderVentilstillingDetailPage = () => {
  return (
    window.location.pathname.search(
      new RegExp(
        `^/rapporter/ventilstillinger/${REGEX_GUID}/ileggelse/${REGEX_GUID}$`,
      ),
    ) !== -1
  );
};

const isVentilstillingDetailPage = () => {
  return (
    window.location.pathname.search(
      new RegExp(`^/rapporter/ventilstillinger/${REGEX_GUID}$`),
    ) !== -1
  );
};
